<template>
  <div class="container">
    <AlertError v-show="!datosEncontrados && !loading" />
    <div class="loading" v-show="loading">
      <Loading />
    </div>
    <section class="indicator" v-show="datosEncontrados && !loading">
      <h5 class="titulo">Indicadores de Desempeño</h5>

      <IndicatorContent
        v-for="(item, index) in datosTabla"
        :key="index"
        :datosTabla="item"
      />
    </section>
  </div>
</template>

<script>
import IndicatorContent from "./IndicatorContent.vue";
import AlertError from "../../../components/error/AlertError.vue";
import Loading from "../../../components/tools/Loading.vue";
import axios from "axios";
import { mapGetters } from "vuex";
export default {
  components: {
    IndicatorContent,
    AlertError,
    Loading,
  },
  data() {
    return {
      datosEncontrados: null,
      datosTabla: null,
      lastYear: 2019,
      loading: true,
    };
  },
  computed: {
    ...mapGetters(["year"]),
  },
  methods: {
    requestData: async function() {
      try {
        let idService = this.$route.params.id
        const res = await axios.get(
          `${process.env.VUE_APP_RUTA_API}/anexos/anexo/public_list/?servicio=${idService}&anexo=16`
        );
        const indicadores = res.data[0] ? res.data[0].datos.indicadores : [];
        if (indicadores.length === 0) {
          setTimeout(() => {
          this.loading = false;
          }, 1000)
          return;
        }

        this.datosTabla = indicadores.map((i) => ({
          strategicProduct: i.strategicProduct
            ? i.strategicProduct.replace("<BR>", "")
            : "",
          indicatorName: i.indicatorName
            ? i.indicatorName.replace("<BR>", "")
            : "",
          indicatorFormula: i.indicatorFormula
            ? i.indicatorFormula.replace("<BR>", "")
            : "",
          itemsTabla: [
            [
              "variables",
              `${this.lastYear - 3}`,
              `${this.lastYear - 2}`,
              `${this.lastYear - 1}`,
              `${this.lastYear}`,
              `meta_${this.lastYear}`,
              `%_de_logro_${this.lastYear}`,
            ],
            [
              {
                variables: "Valor Efectivo",
                [`${this.lastYear - 3}`]:
                  Math.round(i.periodT3 * 100) / 100 + "%",
                [`${this.lastYear - 2}`]:
                  Math.round(i.periodT2 * 100) / 100 + "%",
                [`${this.lastYear - 1}`]:
                  Math.round(i.periodT1 * 100) / 100 + "%",
                [`${this.lastYear}`]: Math.round(i.periodT * 100) / 100 + "%",
                [`meta_${this.lastYear}`]:
                  Math.round(i.goalPeriodT * 100) / 100 + "%",
                [`%_de_logro_${this.lastYear}`]:
                  Math.round(i.logro * 100) / 100 + "%",
                _cellVariants: { variables: "primary" },
              },
            ],
          ],
        }));

        setTimeout(() => {
          this.loading = false;
          this.datosEncontrados = true;
        }, 1000);
      } catch (error) {
        setTimeout(() => {
          this.loading = false;
          this.datosEncontrados = false;
        }, 1000);
        console.log(error);
      }
    },
  },
  mounted() {
    this.requestData();
  },
  watch: {
    year: function() {
      this.requestData();
    },
  },
};
</script>
<style>
.indicator {
  display: flex;
  flex-direction: column;
}
.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 3rem 0;
}
</style>
